<template>
	<v-layout row wrap>

		<v-flex xs12 >
			<h1 class="title mb-2">Users</h1>
			<v-card class="white black--text">

				<v-toolbar card class="white">
					<v-text-field 
					v-model="searchKeyModel"
					v-on:keyup="keyupSearch"
					label="Search user here" 
					single-line prepend-icon="fa-search black--text" 
					full-width hide-details
					class="black--text"
					>
					</v-text-field>
					<v-btn color="primary" @click="clickAddUser">
						<v-icon left>fa-lg fa-plus</v-icon>ADD USER
					</v-btn>
				</v-toolbar>
			<v-divider></v-divider>
			<v-card-text>
				<table class="v-table text-xs-left" style="border:1px solid #ddd;">
					<thead>
						<tr>
							<th style="width:10%;">ID</th>
							<th>Employee ID</th>
							<th>Name</th>
							<th>Department</th>
							<th>Roles</th>
							<th style="width:15%;">Action</th>
						</tr>
					</thead>
					<tbody>
						<tr v-if="users.length==0">
							<td colspan="4" class="text-xs-center">No results found</td>
						</tr>
						<tr v-else v-for="user in users" >
							<td>{{user.id}}</td>
							<td>{{user.employee_id}}</td>
							<td>{{user.fullname}}</td>
							<td>{{user.department}}</td>
							<td>{{user.roles.join(', ')}}</td>
							<td> </td>
						</tr>
					</tbody>
				</table>
			</v-card-text>

			<v-divider></v-divider>
			<v-card-text class="text-xs-center">
				<v-pagination
				total-visible="8"
				next-icon="fa-caret-right"
				prev-icon="fa-caret-left"
				v-model="pagination.page"
				:length="pagination.length"
				light
				></v-pagination>
			</v-card-text>

		</v-card>

	</v-flex>

	<create-user-modal></create-user-modal>
</v-layout>
</template>

<script>
	import VueCookies from 'vue-cookies';
	import axios from 'axios';
	import createUserModal from './createUserModal.vue';

	export default {
		components : {
			'create-user-modal' : createUserModal
		},

		created : function(){
			this.token = (VueCookies.get(this.cookieKey)).token;
		},

		watch : {
			"pagination.page" : function(){
				this.getAndListUsers();
			}
		},

		mounted : function(){
			this.getAndListUsers();

			this.eventHub.$on("newUserWereCreated", () => {
				console.log('newUserWereCreated');
				this.getAndListUsers();
			});
		},

		data : function(){
			return {
				token : '',
				searchKeyModel : '',
				users : [],
				pagination: {
					page : 1,
					length : 0
				},
				typingSeach : null
			}
		},

		methods : {

			clickAddUser : function(){
				this.eventHub.$emit("openCreateUserModal");
			},

			getAndListUsers: function(){
			// show global modal loader
			this.eventHub.$emit("openGlobalLoaderModal");

			this.getUsers()
			.then((response) => {
				this.listToTable(response.data.data);

				this.eventHub.$emit("closeGlobalLoaderModal");
			});
			},

			getUsers : function(){

				return axios.create({
					baseURL : this.apiUrl,
					headers : {
						'Authorization' : `Bearer ${this.token}`
					}
				})
				.get('/users/list', {
					'params' : {
						'page' : this.pagination.page,
						'perpage' : 20,
						'search' : this.searchKeyModel
					}
				});

			},

			listToTable : function(data){
				console.log('data', data);
				this.users = data.users;
				this.pagination.length = data.total_pages;
			},

			keyupSearch : function(){
				clearTimeout(this.typingSeach);

				this.typingSeach = setTimeout(() => {
					this.pagination.page = 1;
					this.getAndListUsers();
				}, 600);
			}

		}

};
</script>